/* 一些公共 api */
import parse from 'url-parse'
import axios from 'crypto-fetch/axios'

/**
 * 根据广告位获取广告
 * @param  {Array}  ids [description]
 * @param  {String}   visitUrl  上次访问的图片链接
 * @param  {String}   visitTime  上次访问的时间戳
 * @return {[type]}
 */
export const getAdInfo = async (ids = [], { visitUrl, visitTime } = {}) => {
  let query = ''
  if (visitUrl) {
    query += `?visitUrl=${visitUrl}&visitTime=${visitTime}`
  }

  const { from: channel } = parse(location.href, true).query
  if (channel) {
    query = query ? `${query}&from=${channel}` : `?from=${channel}`
  }

  const data = await axios.post(`/marketing/spots/display${query}`, ids)

  if (data && Array.isArray(data) && data.length) {
    return data
  }
}

// 获取广告本地存储数据列表，格式化成 getAdInfo api 参数
export const getLocalAdReqBody = (key = '') => {
  let oldImageData = localStorage.getItem(key)
  oldImageData = oldImageData ? JSON.parse(oldImageData) : []

  const body = {}

  if (oldImageData.length) {
    body.visitUrl = oldImageData.map((x) => encodeURIComponent(x.image)).join(',')
    body.visitTime = oldImageData.map((x) => x.date).join(',')
  }
  return { body, oldImageData }
}
